import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { removeFlashMessage } from './flashMessagesSlice'

const FlashMessages = () => {
  const messages = useSelector((state) => state.flash)

  useEffect(() => {
    if (messages.length > 0) {
      const timer = setTimeout(() => {
        // Remove the first message after 5 seconds
        const msg = messages[0]
        if(!msg.persisted) {
          dispatch(removeFlashMessage(0))
        }
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [messages])

  const dispatch = useDispatch()

  const handleClose = (index) => {
    dispatch(removeFlashMessage(index))
  }

  return (
    <div className="fixed top-16 right-4 z-[1000] flex flex-col items-end space-y-2">
      {messages.map((message, index) => (
        <div
          key={index}
          className={`alert ${message.type === 'error' ? 'alert-error' : 'alert-success'} w-auto ml-auto`}
        >
          <div className="flex-1">
              {message.text.split("\n").map(
                (str, index) => <span key={index}>{str}<br/></span>
              )}
          </div>
          <button
            className="ml-2 text-gray-500 hover:text-gray-700"
            onClick={() => handleClose(index)}
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  )
}

export default FlashMessages